import React from 'react';
import PropTypes from 'prop-types';
import { Container, Wrapper } from './styles';

interface IHeader {
  fixed?: boolean;
  children?: React.ReactNode;
}

const Header = ({ fixed, children }: IHeader) => (
  <Container>
    <Wrapper fixed={fixed}>{children}</Wrapper>
  </Container>
);

Header.propTypes = {
  children: PropTypes.node.isRequired,
  fixed: PropTypes.bool,
};

Header.defaultProps = {
  fixed: false,
};

export default Header;
